import { render, staticRenderFns } from "./FeedbackForm.html?vue&type=template&id=8b6abfa0&scoped=true&external"
import script from "./FeedbackForm.vue?vue&type=script&lang=js"
export * from "./FeedbackForm.vue?vue&type=script&lang=js"
import style0 from "./FeedbackForm.css?vue&type=style&index=0&id=8b6abfa0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6abfa0",
  null
  
)

export default component.exports